import React from 'react'
import { Modal } from 'lp-components'

function BenefitDistributionStatusModal({ onClose }) {
  return (
    <Modal id="benefit-distribution-status-modal" onClose={onClose}>
      <div className="benefit-distribution-status-modal_info">
        <h2>Status types</h2>
      </div>
      <div className="benefit-distribution-status-modal_info__text">
        <h5>File received</h5>
        <p>
          We’ve received your participant file. If you haven’t submitted your
          funding yet, submit it now so we can process your distributions.
        </p>
        <h5>Ready for funding</h5>
        <p>
          Your accounts have been opened, and we’re ready for you to send the
          funds to Inspira.
        </p>
        <h5>In progress</h5>
        <p>
          We received your funds and are processing your distributions. Keep in
          mind wire transfers take 1-2 business days and checks take 5 business
          days.
        </p>
        <h5>Complete</h5>
        <p>
          Your distributions have been processed, and payment has been sent to
          participants.
        </p>
        <h5>Not accepted</h5>
        <p>
          We were not able to process your distributions. You can try again or
          email us at{' '}
          <a
            className="email-support"
            href={`mailto:bdplanservicesinquiry@inspirafinancial.com`}
          >
            bdplanservicesinquiry@inspirafinancial.com
          </a>{' '}
          for help.
        </p>
      </div>
      <div className="benefit-distribution-status-modal_button">
        <button className="button-primary" type="button" onClick={onClose}>
          Close
        </button>
      </div>
    </Modal>
  )
}

export default BenefitDistributionStatusModal
